import React, { useEffect, useState, useRef, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./index.css";

const PopUps = ({ Popupss }) => {
  const [visible, setVisible] = useState(false);
  const skipRef = useRef(null);
  const modalRef = useRef(null);
  const lastFocusedRef = useRef(null);

  useEffect(() => {
    let pop_status = localStorage.getItem("pop_status");
    if (!pop_status) {
      setVisible(true);
      localStorage.setItem("pop_status", 1);
    }
  }, []);

  useEffect(() => {
    const clearPopupFlag = () => localStorage.removeItem("pop_status");
    window.addEventListener("beforeunload", clearPopupFlag);
    return () => window.removeEventListener("beforeunload", clearPopupFlag);
  }, []);

  useEffect(() => {
    if (visible) {
      lastFocusedRef.current = document.activeElement;
      if (skipRef.current) {
        skipRef.current.focus();
      }
    } else if (lastFocusedRef.current) {
      lastFocusedRef.current.focus();
    }
  }, [visible]);

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        close();
      }
      if (e.key === "Tab" && modalRef.current) {
        const focusable = modalRef.current.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusable.length) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    },
    [close]
  );

  if (!visible || !Popupss?.length) return null;

  return (
    <div className="MainPopups">
      <div
        className="modal fade show"
        role="dialog"
        aria-modal="true"
        aria-label="Promotional Popup"
        ref={modalRef}
        onKeyDown={handleKeyDown}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            close();
          }
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                className="skip_btns"
                ref={skipRef}
                onClick={close}
                aria-label="Close promotional popup"
              >
                Skip <i className="zmdi zmdi-arrow-right" aria-hidden="true"></i>
              </button>
              <Carousel
                autoPlay={true}
                infiniteLoop={true}
                swipeable={true}
                showStatus={false}
                showIndicators={false}
                showThumbs={false}
                interval={5000}
                pauseOnHover={true}
              >
                {Popupss.map((Pop, index) => {
                  return (
                    <div key={index}>
                      {Pop.file && (
                        <img
                          src={Pop.file}
                          alt={`Promotional popup ${index + 1}`}
                        />
                      )}
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUps;